const fields = {
  date: ['startdate', 'enddate'],
  date_num: ['dates'],
  weekday: ['weekdays'],
  hour: ['hours'],
  device: ['devices'],
  os: ['os'],
  browser: ['browsers'],
  language: ['languages'],
  country: ['countries'],
  city: ['cities'],
  site: ['sites'],
  widget_type: ['widget_types'],
  pixel_targeting: ['urls'],
  capping: ['hours'],
  site_language: ['languages'],
}

function hasValue(value) {
  if (Array.isArray(value)) return value.length > 0 && value.every(hasValue)
  if (value instanceof Date) return !Number.isNaN(value.getTime())
  if (value && typeof value === 'object') {
    return hasValue(value.value === undefined ? value.text : value.value)
  }
  if (typeof value === 'string') return value.split(',').every(part => part.trim() !== '')
  return value !== null && value !== undefined && value !== ''
}

// Validate the form values before serialization can replace empty values with defaults.
export default function invalidTargetings(targetings) {
  return Object.keys(fields).filter(key => {
    const targeting = targetings[key]
    if (!targeting || !['active', 'negative'].includes(targeting.status)) return false
    const params = targeting.params || {}
    if (key === 'capping') return !hasValue(params.hours) || !Number.isFinite(Number(params.hours)) || Number(params.hours) <= 0
    if (key === 'date') {
      return fields.date.some(field => !hasValue(params[field]) || Number.isNaN(new Date(params[field]).getTime()))
    }
    return fields[key].some(field => !hasValue(params[field]))
  })
}
